const normalizeWhitespace = (value: string) => value.trim().replace(/\s+/g, " ");

const hasLetters = (value: string) => /[A-Za-z]/.test(value);

const shouldPreserveWord = (value: string) => {
  if (!hasLetters(value)) return true;
  const hasDigit = /\d/.test(value);
  const isAllCaps = value === value.toUpperCase() && /[A-Z]/.test(value);
  const hasInternalUpper = /[A-Z]/.test(value.slice(1));
  return hasDigit || isAllCaps || hasInternalUpper;
};

const capitalizeWord = (value: string) =>
  value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();

const transformText = (
  text: string,
  mode: "title" | "sentence",
): string => {
  const normalized = normalizeWhitespace(text);
  if (!normalized) return "";

  let wordIndex = 0;
  const tokens = normalized.split(" ");

  return tokens
    .map((token) => {
      const match = token.match(
        /^([^A-Za-z0-9]*)([A-Za-z0-9][A-Za-z0-9'.-]*)([^A-Za-z0-9]*)$/,
      );
      if (!match) return token;
      const [, leading, core, trailing] = match;

      const parts = core.split(/([-/])/);
      const transformedCore = parts
        .map((part) => {
          if (part === "-" || part === "/") return part;
          const preserve = shouldPreserveWord(part);
          const isFirstWord = wordIndex === 0;
          wordIndex += 1;
          if (preserve) return part;
          if (mode === "title") return capitalizeWord(part);
          return isFirstWord ? capitalizeWord(part) : part.toLowerCase();
        })
        .join("");

      return `${leading}${transformedCore}${trailing}`;
    })
    .join(" ");
};

export const formatChartTitle = (title?: string) =>
  title ? transformText(title, "title") : title;

export const formatChartSubtitle = (subtitle?: string) =>
  subtitle ? transformText(subtitle, "sentence") : subtitle;
